<template>
  <footer class="home-footer">
    <div class="home-footer-inner">
      <div class="home-footer-main">
        <div class="home-footer-brand">
          <strong>阿呆云 Rem Video Studio</strong>
          <span>媒体处理与创作效率工具集</span>
        </div>
        <nav class="home-footer-links">
          <router-link to="/common-question">常见问题</router-link>
          <router-link to="/tutorial">使用教程</router-link>
          <router-link to="/service-statement">服务声明</router-link>
        </nav>
        <div class="home-footer-meta">
          <div class="home-footer-item">商务合作: adaiyuns@163.com</div>
          <div class="home-footer-item">©2024-2026 by 阿呆云</div>
          <div class="home-footer-item">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer">蜀ICP备2022009104号-1</a>
          </div>
        </div>
      </div>
      <div class="home-footer-service">
        <div class="home-footer-service__copy">
          <strong>联系客服</strong>
          <span>扫码联系客服，咨询使用、充值或功能问题</span>
        </div>
        <img :src="customServiceImage" alt="联系客服二维码" class="home-footer-service__qr">
      </div>
    </div>
  </footer>
</template>

<script>
import customServiceImage from '@/assets/custom_service.png'

export default {
  name: 'AppFooter',
  data() {
    return {
      customServiceImage
    }
  }
}
</script>

<style scoped>
.home-footer {
  margin-top: auto;
  padding: 24px 28px 28px;
  color: var(--muted);
}

.home-footer-item a {
  color: inherit;
  text-decoration: none;
}

.home-footer-item a:hover {
  text-decoration: underline;
}

.home-footer-inner {
  max-width: 1380px;
  margin: 0 auto;
  padding: 24px 28px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 24px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.82);
  box-shadow: var(--shadow);
  border-radius: 24px;
  min-height: 156px;
}

.home-footer-main {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  justify-content: space-between;
  gap: 18px;
}

.home-footer-brand {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--ink);
}

.home-footer-brand strong {
  font-size: 15px;
}

.home-footer-brand span {
  color: var(--muted);
}

.home-footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.home-footer-links a {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  color: var(--ink);
  text-decoration: none;
  background: rgba(244, 247, 255, 0.96);
  border: 1px solid rgba(214, 224, 238, 0.9);
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.home-footer-links a:hover {
  transform: translateY(-1px);
  border-color: rgba(113, 124, 245, 0.3);
  box-shadow: 0 10px 20px rgba(65, 84, 129, 0.06);
}

.home-footer-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.home-footer-service {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(246, 250, 255, 0.96) 0%, rgba(255, 255, 255, 0.96) 100%);
  border: 1px solid rgba(214, 224, 238, 0.9);
  flex-shrink: 0;
}

.home-footer-service__copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 210px;
}

.home-footer-service__copy strong {
  font-size: 15px;
  color: var(--ink);
}

.home-footer-service__copy span {
  color: var(--muted);
  line-height: 1.7;
}

.home-footer-service__qr {
  width: 108px;
  height: 108px;
  border-radius: 20px;
  background: #ffffff;
  padding: 8px;
  border: 1px solid rgba(214, 224, 238, 0.9);
  box-shadow: 0 10px 24px rgba(65, 84, 129, 0.08);
  object-fit: cover;
}

@media (max-width: 900px) {
  .home-footer {
    padding: 18px 18px 24px;
  }

  .home-footer-inner {
    flex-direction: column;
    padding: 20px;
  }

  .home-footer-main {
    width: 100%;
  }

  .home-footer-links,
  .home-footer-meta {
    justify-content: center;
  }

  .home-footer-brand,
  .home-footer-service__copy {
    text-align: center;
    align-items: center;
  }

  .home-footer-service {
    width: 100%;
    flex-direction: column;
  }
}
</style>
